import { Controller } from "@hotwired/stimulus";

// Mentre un'analisi AI è in corso, interroga lo stato e ricarica la pagina al termine.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 5000 } };

  connect() {
    this.timer = setInterval(() => this.check(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  async check() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } });
      const data = await res.json();
      if (data.stato && data.stato !== "in_corso") {
        clearInterval(this.timer);
        window.Turbo.visit(window.location.href, { action: "replace" });
      }
    } catch (e) { /* riprova al prossimo giro */ }
  }
}
